import { Turret } from "./Turret";
import { Engine } from "../Engine";
import { GameConstants } from "../GameConstants";
import { Glue } from "./shots/Glue";

export class SplatTurret extends Turret {

    public intensity: number;
    public teleportDistance: number;
    public duration: number;
    public durationTicks: number;

    constructor (p: {r: number, c: number}, engine: Engine, skipBuild?: boolean, level?: number) {
        
        super(GameConstants.TURRET_SPLAT, p, engine, skipBuild, level);

        this.teleportDistance = 0;

        this.projectileSpeed = GameConstants.ARROW_SPEED;

        this.calculateTurretParameters();
    }

    // mirar en el ANUTO y generar las formulas que correspondan
    protected calculateTurretParameters(): void {

        this.intensity = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_INTENSITY][this.level - 1];
        this.duration = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_DURATION][this.level - 1];
        this.reload = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RELOAD][this.level - 1];
        this.range = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RANGE][this.level - 1];
        this.priceUpgrade = Math.floor( (1 / 6) * Math.pow(this.level, 3) + 1 * Math.pow(this.level, 2) + (95 / 6) * this.level + 83);

        this.durationTicks = Math.floor(GameConstants.RELOAD_BASE_TICKS * this.duration);

        super.calculateTurretParameters();
    }

    protected shoot(): void {
        
        super.shoot();

        const glue = new Glue(this.position, this.intensity, this.durationTicks, this.range, this.engine);
        this.engine.addGlue(glue, this);
    }
}
